"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**Trunca la parte menos significativa de una fecha */
function truncateDate(value, precision) {
    var year = value.getFullYear();
    var month = value.getMonth();
    var day = value.getDate();
    var hour = value.getHours();
    var minutes = value.getMinutes();
    var seconds = value.getSeconds();
    switch (precision) {
        case "milliseconds":
            return value;
        case "seconds":
            return new Date(year, month, day, hour, minutes, seconds);
        case "minutes":
            return new Date(year, month, day, hour, minutes);
        case "hours":
            return new Date(year, month, day, hour);
        case "days":
            return new Date(year, month, day);
        case "months":
            return new Date(year, month);
        case "years":
            return new Date(year, 0);
    }
}
exports.truncateDate = truncateDate;
/**Suma un valor en cierta unidad a una fecha */
function addDate(date, units, value) {
    var ms = date.valueOf();
    switch (units) {
        case "milliseconds":
            return new Date(ms + value);
        case "seconds":
            return new Date(ms + value * 1000);
        case "minutes":
            return new Date(ms + value * 1000 * 60);
        case "hours":
            return new Date(ms + value * 1000 * 60 * 60);
        case "days":
            return new Date(ms + value * 1000 * 60 * 60 * 24);
        case "months":
            {
                var a = new Date(ms);
                a.setMonth(a.getMonth() + value);
                return a;
            }
        case "years":
            {
                var a = new Date(ms);
                a.setFullYear(a.getFullYear() + value);
                return a;
            }
    }
}
exports.addDate = addDate;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/keautils/dist/dates.js
// module id = 2274
// module chunks = 0